import type { DependencyList } from "react";
import { useLayoutEffect, useRef, useState } from "react";

const useHorizontalOverflowDetection = (deps: DependencyList) => {
  const containerRef = useRef<HTMLElement>(null);
  const [hasOverflow, setHasOverflow] = useState(false);

  const updateOverflow = () => {
    if (containerRef.current) {
      setHasOverflow(containerRef.current.scrollWidth > containerRef.current.offsetWidth);
    }
  };

  useLayoutEffect(() => {
    updateOverflow();
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, [...deps]);

  useLayoutEffect(() => {
    window.addEventListener("resize", updateOverflow);
    return () => window.removeEventListener("resize", updateOverflow);
  }, []);

  return { hasOverflow, containerRef };
};

export default useHorizontalOverflowDetection;
